import { HelpOutline, ReceiptLong, Route, StorefrontOutlined } from '@mui/icons-material';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AirlineSeatReclineExtraIcon from '@mui/icons-material/AirlineSeatReclineExtra';
import ArticleIcon from '@mui/icons-material/Article';
import BusinessIcon from '@mui/icons-material/Business';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import GarageIcon from '@mui/icons-material/Garage';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import PsychologyRoundedIcon from '@mui/icons-material/PsychologyRounded';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SettingsIcon from '@mui/icons-material/Settings';
import ShareLocationOutlinedIcon from '@mui/icons-material/ShareLocationOutlined';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import { Box, Button, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import { FileText } from 'lucide-react';
import { FC, memo } from 'react';

import BetaBadge from './BetaBadge.component';

type Props = {
  navigateToDashboard: (isLogo: boolean) => void;
  navigateToKpis: () => void;
  handlePlanningMenuOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  planningMenuAnchorEl: null | HTMLElement;
  handlePlanningMenuOnClose: () => void;
  navigateToPlanningMap: () => void;
  navigateToPlanningTimeline: () => void;
  navigateToConvenienceDispatches: () => void;
  navigateToPlanningLane: () => void;
  navigateToOrders: () => void;
  handleSettingMenuOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  settingMenuAnchorEl: null | HTMLElement;
  handleSettingMenuOnClose: () => void;
  navigateToContracts: () => void;
  navigateToGarages: () => void;
  navigateToPartnerCompanies: () => void;
  navigateToTrucks: () => void;
  navigateToGroups: () => void;
  navigateToDrivers: () => void;
  navigateToPlaces: () => void;
  navigateToProducts: () => void;
  navigateToAreas: () => void;
  useOutsourcingContractPdf: boolean;
  navigateToOutsourcingContractSettings: () => void;
  navigateToConfig: () => void;
  handleAccountMenuOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  companyName: () => string | undefined;
  userName: () => string | undefined;
  accountMenuAnchorEl: null | HTMLElement;
  handleAccountMenuOnClose: () => void;
  navigateToAccounts: () => void;
  isAdmin: () => boolean;
  navigateToCompany: () => void;
  logout: () => void;
  useTrunkTransportation: boolean;
  navigateToPlanningTrunkTransportation: () => void;
  useLogForSales: boolean;
  navigateToSalesOrders: () => void;
  navigateToShipmentOrders: () => void;
  navigateToShipmentOrderLegs: () => void;
  appEnv: string;
  navigateToPerformanceManagement: () => void;
}

const AppBarLgMenuComponent: FC<Props> = memo((
  {
    navigateToDashboard,
    navigateToKpis,
    handlePlanningMenuOnClick,
    planningMenuAnchorEl,
    handlePlanningMenuOnClose,
    navigateToPlanningMap,
    navigateToPlanningTimeline,
    navigateToConvenienceDispatches,
    navigateToPlanningLane,
    navigateToOrders,
    handleSettingMenuOnClick,
    settingMenuAnchorEl,
    handleSettingMenuOnClose,
    navigateToContracts,
    navigateToGarages,
    navigateToPartnerCompanies,
    navigateToTrucks,
    navigateToGroups,
    navigateToDrivers,
    navigateToPlaces,
    navigateToProducts,
    navigateToAreas,
    useOutsourcingContractPdf,
    navigateToOutsourcingContractSettings,
    navigateToConfig,
    handleAccountMenuOnClick,
    companyName,
    userName,
    accountMenuAnchorEl,
    handleAccountMenuOnClose,
    navigateToAccounts,
    isAdmin,
    navigateToCompany,
    logout,
    useTrunkTransportation,
    navigateToPlanningTrunkTransportation,
    useLogForSales,
    navigateToSalesOrders,
    appEnv,
    navigateToShipmentOrders,
    navigateToShipmentOrderLegs,
    navigateToPerformanceManagement,
  }
) => (
  <>
    <Box pl={2} sx={{ flexGrow: 1, display: 'flex' }}>
      <Button
        onClick={
          () => {
            navigateToDashboard(false);
          }
        }
        startIcon={<HomeOutlinedIcon />}
      >
        ダッシュボード
      </Button>
      <Button
        onClick={
          () => {
            navigateToShipmentOrders();
          }
        }
        startIcon={<ReceiptIcon />}
      >
        案件管理
      </Button>
      {/* <Button
        onClick={
          () => {
            navigateToKpis();
          }
        }
        startIcon={<InsertChartOutlinedIcon />}
      >
        実績参照
      </Button> */}
      <Button
        onClick={
          handlePlanningMenuOnClick
        }
        startIcon={<ShareLocationOutlinedIcon />}
      >
        配車計画
      </Button>
      <Button
        onClick={
          () => {
            navigateToPerformanceManagement();
          }
        }
        startIcon={<InsertChartOutlinedIcon />}
      >
        実績管理
      </Button>
      <Menu
        id="appbar-planning-menu"
        anchorEl={planningMenuAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(planningMenuAnchorEl)}
        onClose={handlePlanningMenuOnClose}
        MenuListProps={{ sx: { p: 0, m: 0, } }}
      >
        <MenuItem
          onClick={
            () => {
              navigateToPlanningMap();
            }
          }
        >
          <ShareLocationOutlinedIcon
            sx={{
              mr: 1
            }}
          />
          マップ
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPlanningTimeline();
            }
          }
        >
          <ViewTimelineIcon
            sx={{
              mr: 1
            }}
          />
          タイムライン
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToConvenienceDispatches();
            }
          }
        >
          <StorefrontOutlined
            sx={{
              mr: 1
            }}
          />
          カード
          <BetaBadge />
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPlanningLane();
            }
          }
        >
          <Route
            sx={{
              mr: 1
            }}
          />
          レーン管理
          <BetaBadge />
        </MenuItem>
        {/* <Stack direction="row" alignItems="center">
          <MenuItem
            onClick={
              () => {
                navigateToPlanningTrunkTransportation();
              }
            }
            disabled={!useTrunkTransportation}
          >
            <DirectionsIcon
              sx={{
                mr: 1
              }}
            />
            幹線輸送
          </MenuItem>
          {!useTrunkTransportation && (
            <Tooltip
              title="幹線輸送機能を利用したい場合はセールス (sales@logpose.co.jp) へご連絡ください。"
            >
              <HelpOutline />
            </Tooltip>
          )}
        </Stack> */}
      </Menu>
      {/* <Button
        onClick={
          () => {
            navigateToOrders();
          }
        }
        startIcon={<BallotIcon />}
      >
        案件一覧
      </Button> */}
      {/* <Button
        onClick={
          () => {
            navigateToShipmentOrderLegs();
          }
        }
        startIcon={<AssignmentIcon />}
      >
        配車一覧
      </Button> */}
      {(appEnv !== 'prd') && (
        <Stack direction="row" alignItems="center">
          <Button
            onClick={
              () => {
                navigateToSalesOrders();
              }
            }
            startIcon={<ReceiptLong />}
            disabled={!useLogForSales}
          >
            受注一覧
          </Button>
          {!useLogForSales && (
            <Tooltip
              title="受注管理機能を利用したい場合はセールス (sales@logpose.co.jp) へご連絡ください。"
            >
              <HelpOutline sx={{ color: 'gray', p: 0, m: 0, }} />
            </Tooltip>
          )}
        </Stack>
      )}
      <Button
        onClick={
          handleSettingMenuOnClick
        }
        startIcon={<SettingsIcon />}
      >
        設定
      </Button>
      <Menu
        id="appbar-setting-menu"
        anchorEl={settingMenuAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(settingMenuAnchorEl)}
        onClose={handleSettingMenuOnClose}
        MenuListProps={{ sx: { p: 0, m: 0, } }}
      >
        <MenuItem
          onClick={
            () => {
              navigateToContracts();
            }
          }
        >
          <FileText
            size={24}
            style={{
              marginRight: 8
            }}
          />
          契約管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToGarages();
            }
          }
        >
          <GarageIcon
            sx={{
              mr: 1
            }}
          />
          車庫管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPartnerCompanies();
            }
          }
        >
          <GroupsIcon
            sx={{
              mr: 1
            }}
          />
          運送会社管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToTrucks();
            }
          }
        >
          <DirectionsCarIcon
            sx={{
              mr: 1
            }}
          />
          車両管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToGroups();
            }
          }
        >
          <GroupIcon
            sx={{
              mr: 1
            }}
          />
          車両グループ管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToDrivers();
            }
          }
        >
          <AirlineSeatReclineExtraIcon
            sx={{
              mr: 1
            }}
          />
          ドライバー管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToAreas();
            }
          }
        >
          <FolderCopyIcon
            sx={{
              mr: 1
            }}
          />
          エリア管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPlaces();
            }
          }
        >
          <PlaceIcon
            sx={{
              mr: 1
            }}
          />
          地点管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToProducts();
            }
          }
        >
          <Inventory2Icon
            sx={{
              mr: 1
            }}
          />
          商品管理
        </MenuItem>
        {(useOutsourcingContractPdf && (
          <MenuItem
            onClick={
              () => {
                navigateToOutsourcingContractSettings();
              }
            }
          >
            <ArticleIcon
              sx={{
                mr: 1
              }}
            />
            委託表設定
          </MenuItem>
        ))}
        <MenuItem
          onClick={
            () => {
              navigateToConfig();
            }
          }
        >
          <PsychologyRoundedIcon
            sx={{
              mr: 1
            }}
          />
          計算エンジン設定
        </MenuItem>
      </Menu>
    </Box>
    <Box>
      <Button
        onClick={handleAccountMenuOnClick}
        startIcon={<AccountCircleRoundedIcon />}
        variant="text"
        size="large"
        sx={{
          py: 0.3,
          px: 1,
          mr: 1,
        }}
      >
        <Stack
          sx={{
            // width: '240px',
            overFlow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Typography
            variant="subtitle2"
            noWrap
          >
            {companyName()}
          </Typography>
        </Stack>
      </Button>
    </Box>
    <Menu
      id="appbar-account-menu"
      anchorEl={accountMenuAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(accountMenuAnchorEl)}
      onClose={handleAccountMenuOnClose}
      MenuListProps={{ sx: { p: 0, m: 0, } }}
    >
      <Typography
        variant="body2"
        noWrap
        sx={{ p: 1 }}
      >
        {userName()}
        さん
      </Typography>
      <MenuItem
        onClick={
          () => {
            navigateToAccounts();
          }
        }
      >
        <PersonIcon
          sx={{
            mr: 1
          }}
        />
        アカウント管理
      </MenuItem>
      {
        isAdmin() && (
          <MenuItem
            onClick={
              () => {
                navigateToCompany();
              }
            }
          >
            <BusinessIcon
              sx={{
                mr: 1
              }}
            />
            会社情報
          </MenuItem>
        )
      }
      <MenuItem
        onClick={
              () => {
                logout();
              }
            }
      >
        <LogoutRoundedIcon
          sx={{
                mr: 1
              }}
        />
        ログアウト
      </MenuItem>
    </Menu>
  </>
));

export default AppBarLgMenuComponent;
